import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  userRoleName: null,
  // other user properties...
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser: (state, action) => {
      console.log("Action Payload userSlice");
      console.log(action.payload);
      state.userRoleName = action.payload.userRoleName;
      // other user properties...
    },
    // other reducers...
  },
});

export const { setUser } = userSlice.actions;

export default userSlice.reducer;